module.exports = __webpack_public_path__ + "static/thumbs_up_emoji-1ca356b4623debc1c77d913030177162.svg";